// extracted by mini-css-extract-plugin
export var fadeIn = "styles-module--fadeIn--8188c";
export var fadeInUp = "styles-module--fadeInUp--d1e72";
export var isInView = "styles-module--is-in-view--469b2";
export var translateInUp = "styles-module--translateInUp--a6ad5";